import React, { CSSProperties } from 'react';
import { IPlaceItem } from '../constants';
import './index.module.less';

//私有常量

//可抽离的逻辑处理函数/组件

let ListItem = (props: IProps) => {
  //变量声明、解构
  const { item, onSelect, selectItem, style = {} } = props;
  const { uniqueId, title, address } = item;

  //组件状态

  //网络IO

  //数据转换
  const isSelect = selectItem && selectItem.uniqueId === uniqueId;
  const distance =
    item.distance &&
    (item.distance >= 1000
      ? (item.distance / 1000).toFixed(2) + 'km'
      : item.distance.toFixed(2) + 'm');

  //逻辑处理函数
  const handleSelect = () => {
    onSelect && onSelect(item);
  };

  //组件Effect

  return (
    <div styleName="item" onClick={handleSelect} style={style}>
      <div styleName="item-name" className="flex">
        <span className="els-maxtwo" styleName="item-name-text">
          {title || ''}
        </span>
        {isSelect ? (
          <i
            className="iconfont icon-chenggong"
            styleName="icon-checked"
            style={{ fontSize: '0.4rem' }}
          />
        ) : null}
      </div>
      <div className="els-maxtwo" styleName="item-address">
        {item.distance > 0 ? (
          <span styleName="item-name-distance">{distance}｜</span>
        ) : null}
        {address || title || ''}
      </div>
    </div>
  );
};

//props类型定义
interface IProps {
  /**
   * 渲染List的位置数据
   */
  item: IPlaceItem;
  /**
   * 点击位置List切换位置事件
   */
  onSelect: (item: IPlaceItem, isSearch?: boolean) => void;
  /**
   * 被选中的List位置数据
   */
  selectItem: IPlaceItem;
  style?: CSSProperties;
}

//prop-type定义，可选

export default ListItem;
